var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarGrid = function SvgCalendarGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 5.4,
    r: 4.4,
    fill: "#FBD15D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6,
    cy: 5.4,
    r: 4.4,
    fill: "#FBD15D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.34,
    r: 9.88,
    fill: "#4AA2C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11.34,
    r: 7.28,
    fill: "#FBD15D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M14.1 14.13a1.56 1.56 0 0 0 0-3.12h-3.28a1.56 1.56 0 1 0 0 3.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E71D42",
    d: "M12.38 8.53a1.56 1.56 0 1 0-3.12 0v4.04a1.56 1.56 0 0 0 3.12 0z"
  })));
};
export default SvgCalendarGrid;